import React from 'react';
/**
 * SubSkillCheatSheet — Renders hints and visual aids for a specific family/skill.
 *
 * Looks up support content from the FAMILY_SUPPORT_REGISTRY and displays
 * hints with LaTeX rendering and optional visual aids.
 *
 * Co-located in practice/ domain (CL-1 s63).
 */

import { ModuleId } from '../../content';
import { type SubSkillHint, FAMILY_SUPPORT_REGISTRY, getHintsForFamilyId } from '../../support';
import { VisualAidFactory } from '../../visuals';
import { LatexRenderer } from '../../components/ui/LatexRenderer';
import { AlertCircle } from 'lucide-react';
interface SubSkillCheatSheetProps {
  moduleId: ModuleId;
  subSkill?: string;
  familyId?: string;
}
export function SubSkillCheatSheet({
  moduleId,
  subSkill,
  familyId
}: SubSkillCheatSheetProps) {
  // Try family-level hints first (most specific), then fall back to subSkill
  const hints: SubSkillHint[] = familyId ? getHintsForFamilyId(familyId) : subSkill ? FAMILY_SUPPORT_REGISTRY[subSkill]?.hints ?? [] : [];
  if (hints.length === 0) {
    return <div className="text-center py-8 text-slate-400" data-id="element-7845">
        <AlertCircle className="w-8 h-8 mx-auto mb-3 opacity-50" data-id="element-7846" />
        <p className="text-sm font-medium" data-id="element-7847">
          Geen hints beschikbaar voor dit onderwerp.
        </p>
      </div>;
  }
  return <div className="space-y-4" data-id="element-7848">
      {hints.map((hint, index) => <div key={index} className="bg-white rounded-xl border border-slate-200 p-4 shadow-sm" data-id="element-7849">
          <h4 className="text-sm font-bold text-slate-700 mb-2" data-id="element-7850">
            <LatexRenderer content={hint.title} data-id="element-7851" />
          </h4>
          <div className="text-sm text-slate-600 leading-relaxed" data-id="element-7852">
            <LatexRenderer content={hint.content} data-id="element-7853" />
          </div>
          {hint.visualAid && <div className="mt-3" data-id="element-7854">
              <VisualAidFactory visualAid={hint.visualAid} isCorrect={undefined} mode="support" data-id="element-7855" />
            </div>}
        </div>)}
    </div>;
}